import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../Styles/Feefrequency.css";
import { simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { FaEye, FaSearch } from "react-icons/fa";

export default function FeeFrequenciesTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  
  // FIXED: Set to null so the conditional render shows the table by default
  const [AccountantStudentFeeListView, setAccountantStudenFeetListView] = useState(null);

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  const loadDataStudentFee = async (searchQuery = "") => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      fee_search: searchQuery,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.FeeStudentList,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        setStudentList(response.data);
        // Ensure detail view is closed when loading the main list
        setAccountantStudenFeetListView(null);
      } else {
        setStudentList([]);
      }
    } catch (error) {
      console.error("Error loading student list:", error);
      setStudentList([]);
    } finally {
      setIsLoading(false);
    }
  };

  const loadDataStudentFeeView = async (id) => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      fee_frequency_id: id,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.FeeStudentListView,
        JSON.stringify(requestBody)
      );
      if (response?.result) {
        // Set the data which triggers the FeeDetailView
        setAccountantStudenFeetListView(response.data || response); 
      } else {
        alert("No data found for this student");
      }
    } catch (error) {
      console.error("Error loading student details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setAccountantStudenFeetListView(null);
  };

  // Normalize common API typos for display
  const normalizeName = (name) => {
    if (!name) return name;
    return String(name).replace(/quaterly/gi, "Quarterly");
  };

  // CONDITIONAL RENDERING: 
  // Because AccountantStudentFeeListView starts as null, this is skipped initially.
  if (AccountantStudentFeeListView) {
    return <FeeDetailView data={AccountantStudentFeeListView} onBack={handleBack} />;
  }

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Fee Frequency</h4>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch
              className="ff-search-icon"
              onClick={() => loadDataStudentFee(searchTerm)}
            />
            <input
              type="text"
              className="form-control ff-search-input"
              placeholder="Search fee frequency..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && loadDataStudentFee(searchTerm)}
            />
          </div>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-4">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Fee Frequency Name</div>
            <div className="yc-list-cell">Fee Frequency Status</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        {/* Rows */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : studentList.length > 0 ? (
          <div className="yc-list-row-list">
            {studentList.map((student, index) => (
              <div key={student.student_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-4">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{normalizeName(student.fee_frequency_name)}</div>
                  <div className="yc-list-cell">{student.fee_frequency_status}</div>
                  <div className="yc-list-cell">
                    <button
                      className="yc-action-icon"
                      onClick={() => loadDataStudentFeeView(student.fee_frequency_id)}
                      title="View"
                    >
                      <FaEye />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No students found</div>
        )}
      </div>
    </div>
  );
}

function FeeDetailView({ data, onBack }) {
  if (!data) return null;

  // Handling both array and object responses
  const invoice = Array.isArray(data) ? data[0] : data;

  // Normalize common API typos for display
  const normalizeName = (name) => {
    if (!name) return name;
    return String(name).replace(/quaterly/gi, "Quarterly");
  };

  return (
    <div className="monthly-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Fee Frequency Details</h4>
        <button className="btn btn-primary" onClick={onBack}>
          Back to List
        </button>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">ID</td>
                    <td>{invoice.fee_frequency_id || invoice.fee_invoice_id || "—"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Fee Frequency Name</td>
                    <td>{normalizeName(invoice.fee_frequency_name) || "—"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Status</td>
                    <td>
                      <span
                        className={`badge ${
                          (invoice.fee_frequency_status || "").toLowerCase() === "active" ||
                          (invoice.fee_frequency_status || "").toLowerCase() === "paid"
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {invoice.fee_frequency_status || "—"}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}